jQuery(document).ready(function ($) {

  $(".row-reviews__slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        },
      },
    ],
  });

});